import type { MouseEvent } from 'react';
import { useCallback } from 'react';
import { useEventFeedStore } from '@/stores/event-feed.store';
import { isOpenInNewTabClick } from '@/utils/mouse';
import { useWatchingState } from './useWatchingState';

export function useFeedPlayback() {
    const onItemSelect = useEventFeedStore((state) => state.feedOnItemSelect);
    const setPlayerHasSeeked = useEventFeedStore(
        (state) => state.setPlayerHasSeeked,
    );
    const getWatchingState = useWatchingState();

    const buildClickHandler = useCallback(
        <T>(
            navigateToItem: (
                item: T,
                clickEvent: MouseEvent<HTMLDivElement>,
            ) => void,
            transformPayload?: (item: T) => unknown,
        ) => {
            return (item: T, clickEvent: MouseEvent<HTMLDivElement>) => {
                // New-tab clicks always navigate to the event page rather than
                // selecting the item in-place.
                if (onItemSelect && !isOpenInNewTabClick(clickEvent)) {
                    clickEvent.preventDefault();
                    clickEvent.stopPropagation();
                    setPlayerHasSeeked(false);
                    const payload = transformPayload
                        ? transformPayload(item)
                        : item;
                    onItemSelect(payload);
                    return;
                }
                navigateToItem(item, clickEvent);
            };
        },
        [onItemSelect, setPlayerHasSeeked],
    );

    return { getWatchingState, buildClickHandler };
}
